<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div class="max-[1024px]:flex-wrap max-[1024px]:gap-5 flex flex-row items-between justify-between gap-8 ">

        <p class="class-[#030308] dark:text-white font-500">Product Shortage Today - Completed</p>

        <div class="max-[1024px]:w-full max-[1024px]:min-w-0 flex flex-row items-center justify-end gap-8">

            <div class="max-[1024px]:max-w-full max-[1024px]:min-w-0 max-[1024px]:mr-0 max-[640px]:w-full max-[1024px]:[&_button]:shrink-0 flex mr-5 items-center rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search By Product & Assignee.." [(ngModel)]="searchText"
                    class="bg-transparent outline-none w-full max-[1024px]:min-w-0 text-textLight dark:text-textDark"
                    (keyup.enter)="onSearch()" (keyup.esc)="offSearch()" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>

    </div>


    <div *ngIf="hasData"
        class="max-[1024px]:mr-0 max-[1024px]:min-w-0 overflow-x-auto mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="max-[1024px]:min-w-max w-full divide-y-2 overflow-hidden">
            <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                <tr>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">No</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Image</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Product Name</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-center font-medium">Shortage (kg)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Price per kg (Rs.)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Assignee</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-center font-medium">Purchased (kg)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Purchase Price Per kg (Rs.)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Purchase Time</th>
                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F] cursor-default">
                <tr *ngFor="let item of itemsArr; let i = index">
                    <td class="px-6 py-4 text-[#000000] font-500 text-left dark:text-gray-300">
                        {{ i + 1 | number:'2.0' }}
                    </td>
                <td class="px-6 py-4 whitespace-nowrap text-[#000000] font-500 text-left dark:text-gray-300"> <img [src]="item.image" alt="Image"
                        class="w-10 h-10 rounded-full object-cover" /> </td>
                <td class="px-6 py-4  whitespace-nowrap text-[#000000] font-500 text-left dark:text-gray-300">{{item.displayName}}</td>
<td class="px-6 py-4 whitespace-nowrap text-center">
  <div class="inline-flex items-center justify-center rounded-md bg-[#FEF7EF] px-3 py-1">
    <span class="text-[#9D6C00] font-semibold">
      {{ item.qty | number:'1.3-3' }}
    </span>
  </div>
</td>

            <td class="px-6 py-4  whitespace-nowrap text-[#9D6C00] text-left font-600 dark:text-[#9D6C00]">{{ item.price | number:'1.2-2' }}</td>
                <td class="px-6 py-4 text-[#000000] text-left font-500 dark:text-gray-300">{{item.empId || "----"}}
                </td>
<td class="px-6 py-4 whitespace-nowrap text-center">
  <div class="inline-flex items-center justify-center rounded-md bg-[#EDF5FC] px-3 py-1 min-w-[48px]">
    <span class="text-[#415CFF] font-semibold">
      {{ item.prchQty ? (item.prchQty | number:'1.3-3') : '----' }}
    </span>
  </div>
</td>
                <td class="px-6 py-4 whitespace-nowrap text-[#415CFF] text-left font-600 dark:text-gray-300">
  {{ item.prchPrice ? (item.prchPrice | number:'1.2-2') : "----" }}
</td>
                <td class="px-6 py-4 whitespace-nowrap text-[#000000] text-left font-500 dark:text-gray-300">{{item.createdAt | date:
                    'hh:mm a on yyyy/MM/dd'}}</td>
                </tr>
            </tbody>
        </table>

    </div>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen max-[640px]:px-2 max-[640px]:text-center px-10 py-7 mt-6 ">
        <p class="text-[#494949] my-6 dark:text-textDark">--No Data Available--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>

</div>